import { render, staticRenderFns } from "./AlphaNumHalfKanaTextField.vue?vue&type=template&id=6922fc52&scoped=true&"
import script from "./AlphaNumHalfKanaTextField.vue?vue&type=script&lang=ts&"
export * from "./AlphaNumHalfKanaTextField.vue?vue&type=script&lang=ts&"
import style0 from "./AlphaNumHalfKanaTextField.vue?vue&type=style&index=0&id=6922fc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922fc52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
